import * as React from 'react';
import Button from 'shared/components/Button';

const Buttons = () => {
  return (
    <div>
      <div className='mb-8'>
        <Button className='btn-primary mr-8'>Primary</Button>
        <Button className='btn-outline-primary mr-8'>Outline Primary</Button>
        <Button className='btn-outline-primary btn-outline-fixed mr-8'>Outline Primary Fixed</Button>
        <Button className='btn-outline-dark'>Outline Dark</Button>
      </div>
      <div className='mb-8'>
        <Button className='btn-sm btn-primary mr-8'>Primary</Button>
        <Button className='btn-sm btn-outline-primary mr-8'>Outline Primary</Button>
        <Button className='btn-sm btn-outline-primary btn-outline-fixed mr-8'>Outline Primary Fixed</Button>
        <Button className='btn-sm btn-outline-dark'>Outline Dark</Button>
      </div>
      <div className='mb-8'>
        <Button className='btn-sm btn-gray-light mr-8'>Gray Light</Button>
      </div>
    </div>
  );
};

export default Buttons;
